<template>
	<div class="c-profile" v-if="isAuth">
		<PageHeader byline="Profile & Settings">
			<template v-slot:title> Profile, workspace & billing </template>
		</PageHeader>

		<div class="container" v-if="workspace">
			<div class="row">
				<div class="col-12">
					<!-- Tabs -->
					<div class="c-profile__tabs">
						<router-link :to="`/profile`">
							<span>Profile Settings</span>
							<p>Update your Profile's settings</p>
						</router-link>
						<router-link :to="`/profile/workspace`">
							<span>Workspace Settings</span>
							<p>Update your Workspace's settings & invite users</p>
						</router-link>
						<router-link :to="`/profile/billing`">
							<span>Billing Portal</span>
							<p>Upgrade to Pro / Access your billing portal from here</p>
						</router-link>
					</div>
					<!-- Tabs END -->

					<div class="c-profile__inner">
						<router-view></router-view>

						<template v-if="!workspace.activated">
							<h5>Heads up</h5>
							<p>
								You haven't verified your email. Please verify to use all
								features of your account.
							</p>
							<FormVerificationEmail
								v-if="!hasResentVerificationEmail"
								@onSubmit="hasResentVerificationEmail = true"
							></FormVerificationEmail>

							<br />
							<br />
						</template>

						<template v-if="showProfile">
							<Box>
								<template v-slot:header>
									<h3>Personal Settings</h3>
								</template>
								<template v-slot:body>
									<div class="container-fluid">
										<div class="row">
											<div class="col-md-6">
												<h4>Profile settings</h4>
												<p>
													Update your personal settings like name and profile
													picture.
												</p>
											</div>
											<div class="col-md-6">
												<FormSettings></FormSettings>
											</div>
										</div>
									</div>

									<div class="container-fluid">
										<div class="row">
											<div class="col-md-6">
												<h4>Email settings</h4>
												<p>Update your email from here.</p>
											</div>
											<div class="col-md-6">
												<FormEmailUpdate></FormEmailUpdate>
											</div>
										</div>
									</div>

									<div class="container-fluid">
										<div class="row">
											<div class="col-md-6">
												<h4>Password settings</h4>
												<p>Update your account's password from here.</p>
											</div>
											<div class="col-md-6">
												<FormPasswordUpdate> </FormPasswordUpdate>
											</div>
										</div>
									</div>

									<hr />

									<div class="container-fluid">
										<div class="row">
											<div class="col-md-6">
												<a
													@click.prevent="logout"
													href="#"
													class="btn btn-icon"
												>
													<svg
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M12 2V12M16 4.93555C18.9634 6.40825 21 9.46631 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.46631 5.03656 6.40825 8 4.93555"
															stroke="currentColor"
															stroke-width="1.5"
															stroke-linecap="round"
														/>
													</svg>
													Logout
												</a>
											</div>
										</div>
									</div>
								</template>
							</Box>

							<br />
							<br />

							<Box>
								<template v-slot:header>
									<h3>Stats</h3>
								</template>
								<template v-slot:body>
									<WorkspaceUserStats></WorkspaceUserStats>
								</template>
							</Box>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header.vue';

import FormSettings from '@swipekit/components/form/form-settings';
import FormEmailUpdate from '@swipekit/components/form/form-email-update';
import FormPasswordUpdate from '@swipekit/components/form/form-password-update';

import Box from '@swipekit/components/utils/box';
import FormVerificationEmail from '@swipekit/components/form/form-verification-email';

import WorkspaceUserStats from '@swipekit/components/workspace/user-stats';

export default {
	name: 'Home',
	components: {
		PageHeader,
		FormSettings,
		FormEmailUpdate,
		FormVerificationEmail,
		Box,
		WorkspaceUserStats,
		FormPasswordUpdate,
	},

	data: function () {
		return {
			hasResentVerificationEmail: false,
		};
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		showProfile: function () {
			let route = this.$route;

			if (route.fullPath === '/profile') {
				return true;
			}

			return false;
		},
	},

	methods: {
		logout: function () {
			this.$store.dispatch('users/logout');
		},
	},
};
</script>

<style lang="scss">
.c-profile {
	padding-bottom: var(--spacer);

	.container {
		padding: 0 var(--spacer-sm);
		margin: 0 auto;
	}

	.c-table > table {
		border-radius: 10px;
		overflow: hidden;
		display: block;
		border: var(--color-bg-5) solid 1px;
	}

	&__account {
		padding: var(--spacer);
		border: var(--color-input-background) solid 1px;
		border-radius: var(--border-radius);

		li {
			margin-bottom: var(--margin);
		}

		.c-spinner {
			margin-right: var(--margin-lg);
		}
	}

	&__inner {
		padding: var(--spacer) 0;
	}

	&__tabs {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		margin-top: var(--margin-lg);

		a {
			display: inline-block;
			padding: var(--margin-lg) var(--spacer-sm);
			font-weight: 450;
			color: var(--color-font) !important;
			background-color: var(--color-bg-1);
			border-bottom: var(--color-bg-4) solid 3px;
			text-decoration: none !important;

			&:hover,
			&.router-link-exact-active {
				background-color: hsla(var(--p), 65%, 65%, 0.1);
				border-bottom-color: var(--color-primary);
			}

			p {
				margin-bottom: 0;
				opacity: 0.75;
				font-size: var(--font-size-sm);
				font-weight: 400;
			}
		}
	}

	.c-table {
		a {
			word-break: break-all;
		}

		tr {
			td:first-child {
				opacity: 0.85;
			}
		}
	}

	@media (max-width: 768px) {
		&__tabs {
			p {
				display: none;
			}
		}

		.c-table {
			tr {
				grid-template-columns: 1fr;
				border-bottom: var(--color-bg-5) solid 1px;
			}
			td {
				border-bottom: none;
			}
		}
	}
}
</style>
